module.exports = __webpack_public_path__ + "static/media/favicon.291eccc8.ico";